import PropTypes from 'prop-types';

function IFShopByActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M11.203 15.2613L9.76793 12.9541L26.5844 15.2907L28.0195 17.5978L11.203 15.2613Z"
                fill="#C5DB66"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.0208 17.5995L11.2047 15.2617L8.8669 32.0779L25.6831 34.4157L28.0208 17.5995Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M34.1936 18.4571L28.0182 17.5986L25.6805 34.4148L31.8559 35.2733L34.1936 18.4571Z"
                fill="#C5DB66"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M35.6861 22.8779L29.5102 22.019L28.0195 17.5986L34.1925 18.4573L35.6861 22.8779Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.4901 11.5983C24.6054 10.4728 24.7984 7.96297 24.7984 7.96297"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M30.1053 13.5239C30.6283 12.9947 31.7374 11.7803 31.7374 11.7803"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7603 10.9552C17.5029 10.2499 16.8724 8.7002 16.8724 8.7002"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default IFShopByActive;

IFShopByActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFShopByActive.defaultProps = {
    className: null,
    width: 28,
};
